module.exports = __webpack_public_path__ + "b5f3665eb9d9b0bc63c4897e2d198746.MP3";